import { ToastProvider } from "@/utils/toast";
import { useAuth } from "@clerk/clerk-react";
import { useTheme } from "@heroui/react";
import { SolarProvider } from "@solar-icons/react";
import { Outlet } from "react-router";
import { QueryParamProvider } from "use-query-params";

import AuthLoadingScreen from "@/components/loading/auth";
import PwaUpdatePrompt from "@/components/pwa/update-prompt";
import { ReactRouter6Adapter } from "use-query-params/adapters/react-router-6";

export default function RootLayout() {
  const { isLoaded } = useAuth();
  useTheme();

  if (!isLoaded) {
    return (
      <QueryParamProvider adapter={ReactRouter6Adapter}>
        <SolarProvider
          value={{ size: "20", weight: "Broken", color: "#71717A" }}
        >
          <ToastProvider />
          <main className="text-foreground !overflow-x-hidden">
            <AuthLoadingScreen />
          </main>
        </SolarProvider>
      </QueryParamProvider>
    );
  }

  return (
    <QueryParamProvider adapter={ReactRouter6Adapter}>
      <SolarProvider value={{ size: "20", weight: "Broken", color: "#71717A" }}>
        <ToastProvider placement="bottom end" />
        <div className="text-foreground min-h-dvh h-full">
          <Outlet />
        </div>
        <PwaUpdatePrompt />
      </SolarProvider>
    </QueryParamProvider>
  );
}
